export const WEB_APP_LINK = "https://app.ferritico.com/";
